import { Component } from 'react';
import isEqual from 'lodash-es/isEqual';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';

import Preloader from '../../../Preloader';
import ProviderBody from './ProviderBody';

import withMetatag from '../../../../decorators/metadataDecorators/metatagsTitleDecorator';
import withComponentName from '../../../../decorators/withComponentName';
import permissionsDecorator from '../../../../decorators/permissionsDecorator';
import { filingsParamGenerate } from '../../../../helpers/identifierParamHelpers';
import { setTopicAssetType } from '../../../../helpers/topicsApiHelpers';

export class Filings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rendered: false,
      extraProps: {},
      hideFilingsList: false,
      isSingleTopic: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    this.setState({
      rendered: true,
    });
    this.setExtraProps();
  }

  componentDidUpdate(prevProps) {
    const { activeWatchlistTopics } = this.props;
    if (!isEqual(activeWatchlistTopics, prevProps.activeWatchlistTopics)) {
      this.setExtraProps();
    }
  }

  setExtraProps() {
    const { activeWatchlistTopics } = this.props;

    const extraProps = activeWatchlistTopics
      .filter((f) => f.entity_type === 'Stocks' || f.entity_type === 'Private Companies and Brands')
      .map((watchlist) => {
        const {
          legal_entities: legalEntities, tickers, hidden, entity_type: entityType,
        } = watchlist;

        if (hidden) return;

        const assetType = setTopicAssetType(entityType);
        const identifier = filingsParamGenerate({
          tickers,
          legal_entities: legalEntities,
        }, assetType);

        return identifier;
      }).filter((f) => f).join(',');

    const isSingleTopic = activeWatchlistTopics
      .filter(({ hidden, entity_type: entityType }) => !hidden && (entityType === 'Stocks' || entityType === 'Private Companies and Brands'))
      .length === 1;

    this.setState({
      extraProps: extraProps ? { identifier: extraProps } : {},
      hideFilingsList: !extraProps,
      isSingleTopic,
    });
  }

  render() {
    const {
      activatePreloader,
      activateFilingsPreloader,
      piwikEnabled,
    } = this.props;

    const {
      rendered,
      extraProps,
      hideFilingsList,
      isSingleTopic,
    } = this.state;

    if (!rendered || (activatePreloader && activateFilingsPreloader)) {
      return <Preloader loading centered static />;
    }

    return (
      <ProviderBody
        hasSourceAccess
        hasTabHeader
        isWatchlists
        extraProps={extraProps}
        hideFilingsList={hideFilingsList}
        isSingleTopic={isSingleTopic}
        piwikEnabled={piwikEnabled}
      />
    );
  }
}

const mapStateToProps = ({ watchlistReducer }) => ({
  activeWatchlistTopics: watchlistReducer.activeWatchlistTopics,
  activatePreloader: watchlistReducer.activatePreloader,
  activateFilingsPreloader: watchlistReducer.activateFilingsPreloader,
});

export default withComponentName(
  connect(mapStateToProps, null)(permissionsDecorator(withMetatag(Filings, 'watchlists/filings'))),
);
